import React from 'react';

import { Box, Typography } from '@mui/material';
import PendingChangeWrapper from '@sharedCR/common/PendingChangeWrapper';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';
import { PendingChangesActionType } from 'constants/pendingChanges';

import { iconRowWrapperStyles } from './IconRow.styles';

const IconRow = ({ icon: Icon, value, isModified = false, authors = null, fieldLabel = '' }) => (
  <Box sx={iconRowWrapperStyles}>
    <Icon size={IconSize[16]} />
    <PendingChangeWrapper
      isSmall
      authors={authors}
      fieldLabel={fieldLabel}
      pendingChangesActionType={isModified ? PendingChangesActionType.MODIFIED : undefined}
      textSelector="span"
    >
      <Typography color="text.secondary" component="span" variant="medium16">
        {value}
      </Typography>
    </PendingChangeWrapper>
  </Box>
);

IconRow.propTypes = {
  icon: PropTypes.elementType.isRequired,
  authors: PropTypes.arrayOf(PropTypes.object),
  fieldLabel: PropTypes.string,
  isModified: PropTypes.bool,
  value: PropTypes.node,
};

export default IconRow;
